export enum LCRRTierType {
  'Tier1' = 1,
  'Tier2' = 2,
  'Tier3' = 3,
  'Tier4' = 4,
  'Tier5' = 5
}
